/*
* custom
*/

// never every overwrite window.$ or window.jQuery here if fec is in use!
// this would cause $.ajaxSetup to malfunction since this file will be loaded after the fec-client.
const $ = require('jquery')
window.$ = window.$ || $
window.jQuery = window.jQuery || $
var $window = $(window);
var winWidth = $window.width()
const Swiper = require('swiper/swiper-bundle.min.js');
const Shariff = require('shariff');


$(document).ready(function ($) {

	$('#butMobileNav').on('click', function(){
		var $nav = $('header nav');
		if ($nav.css('display')==='none') {
			$nav.css('display','block');
			$('#topNav').css('padding-left',$('#mobileNav').offset().left);
			$('html').css('overflow-y','hidden');
			$(this).hide();
			$('#butMobileNavClose').show();
		} else {
			$nav.hide();
			$(this).show();
			$('#butMobileNavClose').hide();
			$('html').css('overflow-y','auto');
		}
	});
	$('#butMobileNavClose').on('click', function(){
		var $nav = $('header nav');
		if ($nav.css('display')==='block') {
			$nav.hide();
			$(this).hide();
			$('#butMobileNav').show();
			$('html').css('overflow-y','auto');
		} else {
			$nav.css('display','block');
			$(this).show();
			$('html').css('overflow-y','hidden');
			$('#butMobileNavClose').show();
		}
	});

	// handle form button
	var $btnContactForm = $('#btnContact');
	if ($btnContactForm.length) {
		$btnContactForm.click(function() {
			custom.submitForm($btnContactForm.data('frm'),false);
		});
	}

	// TODO: wt: approve and / or cleanup
	custom.eventTicker.init();
	// custom.initEventTicker();
	custom.initSwipers();
	custom.handleCookiePolicyBar();
	custom.initContentGallery();
	custom.addShariff();
});

$window.resize(function() {
	custom.handleCookiePolicyBar(true);
	if (winWidth !== $window.width()) {
		if ($('#mobileNav').css('display')==='block') {
			$('header nav').hide();
			$('#butMobileNavClose').hide();
			$('#butMobileNav').show();
		} else {
			if ($window.width()>=1200) {
				$('header nav').css('display','inline-flex');
			}
		}
	}
});

$window.scroll(function() {

	if ($window.scrollTop() > 70) {
		$('#logo').addClass('scrolling')
	} else {
		$('#logo').removeClass('scrolling')
	}
});
// web-object
var custom = window.custom = {

	raTypeUpdated: function (dd) {
		var $ddType = $(dd);
		var $ddYear = $('#ra_year');
		var type = parseInt($ddType.val());
		$('#ra_step3').hide();
		$('#ra_result').html('');
		if (!(type>0)) {
			$('#ra_step2').hide();
		} else {
			var options = '', addYear = false, y, i;
			$ddYear.html('');
			for (y=0; y<(raYearLookup || []).length; y++) {
				addYear = false;
				for (i=0; i<(raData || []).length; i++) {
					if (raData[i].year === raYearLookup[y].id && raData[i].type === type) {
						addYear = true;
					}
				}
				if (addYear) {
					options += '<option value="' + raYearLookup[y].id + '">' + raYearLookup[y].name + '</option>';
				}
			}
			$ddYear.html('<option selected value="-">Bitte wählen Sie ein Jahr!</option>' + options);
			$('#ra_step2').show();
		}
	},
	raYearUpdated: function (dd) {
		var $ddYear = $(dd);
		var type = parseInt($('#ra_type').val());
		var year = parseInt($ddYear.val());

		var $list = $('#ra_result');
		var data = '';
		var d;
		for (var i=0; i<(raData || []).length; i++) {
			d = raData[i];
			if (d.year === year && d.type === type) {
				data += '<li><a href="' + d.url + '" target="_blank"><i class="fis fi-file-' + d.ext + '" aria-hidden="true"></i><span>' + d.name + ' (' + d.size + ')</span></a></li>';
			}
		}
		$list.html(data);
		$('#ra_step3').show();
	},

	eventTicker: {
		$eventCountdown: null,
		eventCountdownInterval: null,
		eventTS: null,

		init: function(){
			this.$eventCountdown = $('#eventCountdown');
			if (this.$eventCountdown.length) {
				this.eventTS = this.$eventCountdown.addClass('sN').data('ets')*1;
				this.update(this)
				this.eventCountdownInterval = setInterval(this.update, 1000, this)
			}
		},

		update: function(self){
			if(self.eventTS && self.$eventCountdown){
				var now  = new Date().getTime();
				var diff = self.eventTS - now;
				document.getElementById('cntdwn_d').innerHTML = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2,'0');
				document.getElementById('cntdwn_h').innerHTML = String(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2,'0');
				document.getElementById('cntdwn_m').innerHTML = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2,'0');
				document.getElementById('cntdwn_s').innerHTML = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2,'0');
				if (diff <= 0) {
					clearInterval(self.eventCountdownInterval);
					self.$eventCountdown.hide();
				}
			}
		}
	},

	// initEventTicker: function () {
	// 	var $eventCountdown = $('#eventCountdown').addClass('sN');
	// 	if ($eventCountdown.length) {
	// 		var eventTS = $eventCountdown.data('ets')*1;
	// 		var eventCountdownIntervall = setInterval(function() {
	// 			var now  = new Date().getTime();
	// 			var diff = eventTS - now;
	// 			document.getElementById('cntdwn_d').innerHTML = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2,'0');
	// 			document.getElementById('cntdwn_h').innerHTML = String(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2,'0');
	// 			document.getElementById('cntdwn_m').innerHTML = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2,'0');
	// 			document.getElementById('cntdwn_s').innerHTML = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2,'0');
	// 			if (diff <= 0) {
	// 				clearInterval(eventCountdownIntervall);
	// 				$eventCountdown.hide();
	// 			}
	// 		}, 1000);
	// 	}
	// },

	validateEmail : function(email) {
		var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
		return re.test(email);
	},

	initSwipers: function() {
		var $swipers = $('.swiper-container');
		if ($swipers.length > 0) {
			$swipers.each(function () {
				if ($(this).data('slide-count') > 1) {
					var sc = {
						preloadImages: false,
						loop: true,
						lazy: true,
						autoplay: {
							delay: 5000,
							disableOnInteraction: true,
						},
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						pagination: {
							el: '.swiper-pagination',
							clickable: true
						}
					};
					if ($(this).hasClass('gallery')) {
						sc = {
							slidesPerView: 2,
							spaceBetween: 20,
							// init: false,
							pagination: {
								el: '.swiper-pagination',
								clickable: true,
							},
							breakpoints: {
								768: {
									slidesPerView: 3,
									spaceBetween: 25,
								},
								992: {
									slidesPerView: 4,
									spaceBetween: 25,
								},
								1200: {
									slidesPerView: 5,
									spaceBetween: 25,
								},
							}
						};
					}
					new Swiper($(this)[0], sc);
				}
			});
		}
	},

	addShariff: function() {
		const $shariff = $('#shariff')
		if($shariff.length > 0){
			new Shariff($shariff, {
				orientation: 'horizontal',
				buttonStyle: 'icon',
				services: ['facebook', 'twitter', 'pinterest', 'linkedin'],
				lang: 'de'
			});
		}
	},

	submitForm : function(formID, forceSubmit)
	{
		var $form = $('#' + formID);

		// form is forced
		if (forceSubmit === true) $('#district').val('');

		// disable button
		var $button = $('#btnContact');
		$button.prop('disabled',true);

		// validate required fields
		var isValid = true;
		$('form :input, form :checked').each(function() {
			var $field = $(this);
			var fieldType = $field.attr('type');
			var fieldName = $field.attr('name');
			var fieldValue = $field.val();
			if ($field.attr('required') && (fieldValue === "" ||
				(fieldType==='email' && fieldValue !== "" && !custom.validateEmail(fieldValue)) ||
				(fieldType === 'checkbox' && !$field[0].checked))) {
				$field.addClass('is-invalid');
				isValid = false;
			} else {
				$field.removeClass('is-invalid');
			}
		});

		// prepare alert boxes
		var validationErrorMsg = 'Bitte füllen Sie alle Pflichtfelder korrekt aus und aktivieren Sie die Einverständniserklärung.';
		var $successBox = $('#frmContactSuccess');
		var $errorBox 	= $('#frmContactError');
		$successBox.hide();
		$errorBox.hide();

		if (!isValid) {
			$errorBox.html(validationErrorMsg).show();
			$button.prop('disabled',false);

		} else {

			$.ajax({
				url: 	'/~/de/sendContactForm',
				method: 'post',
				data: 	$form.serialize(),
				cache:	false,
				async: 	true

			}).done(function(res) {
				if (res.success === true) {
					$('html, body').animate({'scrollTop': $form.offset().top-50}, 400);
					$successBox.html(res.msg).show();
					$('.frmDone').hide();
				} else {
					var html;
					if (typeof res.data != 'undefined') {
						html = validationErrorMsg;
						for (var i in res.data) {
							$form.find('input[name=' + res.data[i].field + ']').addClass('is-invalid');
						}
					} else if (res.msg) {
						if (res.msg === 'honeypot-trap') {
							html = 'Der Spam-Schutz dieses Formulars hat angeschlagen.<br>Bitte ' +
								'<a href="javascript:custom.submitForm(\'' + formID + '\',true)">klicken Sie hier</a> um das Formular abzusenden.';
						} else {
							html = '<b>' + res.msg + '</b><br>';
						}
					} else {
						html = '<b>Beim Versenden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal oder senden Sie Ihre Anfrage direkt an post@sc-lofer.at.</b>';
					}
					$errorBox.html(html).show();
					$button.prop('disabled',false);
				}
			}).fail(function(res) {
				$errorBox.html(res.data).show();
				$button.prop('disabled',false);
			});
		}
	},

	handleCookiePolicyBar: function(resizeCall) {

		if (typeof resizeCall === "undefined") resizeCall = false;
		var cookieName = "NECESSARY_COOKIES_ACCEPTED";
		// cookie-policy-bar must be displayed
		if (document.cookie.indexOf(cookieName)===-1) {
			var $cookiePolicyBar = $('.cookie-policy-bar');
			//show bar and
			$cookiePolicyBar.show();
			// handle button action
			if (!resizeCall) {
				$cookiePolicyBar.find('button').on('click',function(){
					// set cookie to remember
					var d = new Date();
					d.setTime(d.getTime() + (31*24*60*60*1000));
					document.cookie = cookieName + "=true;expires=" + d.toUTCString() + ";path=/";
					// remove cookie-bar
					$(this).parent().hide();
				});
			}
		}
	},

	initContentGallery: function () {
		var $galleries = $('.gallery-wrapper');
		if ($galleries.length > 0) {
			$galleries.each(function(index) {
				var $gallery = $(this);
				var galleryData = $gallery.data('gallery');
				$gallery.find('img').each(function(index) {
					var $img = $(this);
					$img.on('click',function(e){
						// var pswpElement = document.getElementById('pswp');
						if (!galleryData) return;
						var entries = galleryData.split('||');
						var items = [];
						for (var i=0;i<entries.length;i++) {
							var img = entries[i].split('##');
							if (img.length === 3) {
								items.push({
									w: 		img[0],
									h:		img[1],
									src:	img[2]
								});
							}
						}

						custom.openLightBox(
							items,
							{ index: index } // start with this slide
						);
					});
				});
			});
		}
	},

	openLightBox: function(items, options) {
		var pswpElement = document.getElementById('pswp');
		var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
	}
};

/**
 * String.prototype.padStart() polyfill
 * https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
 */
if (!String.prototype.padStart) {
	String.prototype.padStart = function padStart(targetLength,padString) {
		targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
		padString = String((typeof padString !== 'undefined' ? padString : ' '));
		if (this.length > targetLength) {
			return String(this);
		}
		else {
			targetLength = targetLength-this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
			}
			return padString.slice(0,targetLength) + String(this);
		}
	};
}